import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import ResultPreview from "@/components/site/ResultPreview";
import History from "@/components/site/History";
import Stats from "@/components/site/Stats";
import Features from "@/components/site/Features";
import HowItWorks from "@/components/site/HowItWorks";
import InlineCTABanner from "@/components/site/InlineCTABanner";
import WhoIsThisFor from "@/components/site/WhoIsThisFor";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import FloatingCTA from "@/components/site/FloatingCTA";
import ThemeToggle from "@/components/site/ThemeToggle";
import { extractAd } from "@/lib/api";
import { addToHistory, getHistory } from "@/lib/history";

export default function Home() {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [ad, setAd] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    setHistory(getHistory());
  }, []);

  const handleExtract = useCallback(async (submittedUrl) => {
    const target = (submittedUrl ?? url).trim();
    if (!target) {
      toast.error("Please paste a Facebook Ad Library URL");
      return;
    }
    setLoading(true);
    setAd(null);
    try {
      const result = await extractAd(target);
      setAd(result);
      const next = addToHistory(result);
      setHistory(next);
      toast.success("Ad extracted — ready to download");
      setTimeout(() => {
        const el = document.getElementById("result");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } catch (err) {
      const detail =
        err?.response?.data?.detail ||
        err?.message ||
        "Something went wrong extracting the ad";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  }, [url]);

  const handleRerun = (savedUrl) => {
    setUrl(savedUrl);
    handleExtract(savedUrl);
  };

  return (
    <div className="min-h-screen relative">
      <Nav />
      <Hero
        url={url}
        setUrl={setUrl}
        onSubmit={() => handleExtract()}
        loading={loading}
      />
      <ResultPreview ad={ad} loading={loading} />
      <History items={history} onRerun={handleRerun} setHistory={setHistory} />
      <Stats />
      <Features />
      <HowItWorks />
      <InlineCTABanner />
      <WhoIsThisFor />
      <Testimonials />
      <FAQ />
      <Footer />
      <FloatingCTA />
      <ThemeToggle />
    </div>
  );
}
